import { render, staticRenderFns } from "./CartLimitationFormData.vue?vue&type=template&id=673f17bc&scoped=true"
import script from "./CartLimitationFormData.vue?vue&type=script&lang=js"
export * from "./CartLimitationFormData.vue?vue&type=script&lang=js"
import style0 from "./CartLimitationFormData.vue?vue&type=style&index=0&id=673f17bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f17bc",
  null
  
)

export default component.exports